/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

class SensesObject {
  blindsight:        number = 0;
  blindbeyond:       boolean = false;
  darkvision:        number = 0;
  tremorsense:       number = 0;
  truesight:         number = 0;
  passiveperception: number = 10;
  customString:      string = '';

  public static isBlank = (sensesObject: SensesObject): boolean => {
    return sensesObject.blindsight  === 0 && 
           sensesObject.blindbeyond === false &&
           sensesObject.darkvision  === 0 &&
           sensesObject.tremorsense === 0 &&
           sensesObject.truesight   === 0 &&
           sensesObject.passiveperception === 10 &&
           !sensesObject.customString;
  }

  public static parseFromString = (sensesStr: string | null | undefined): SensesObject => {
    const sensesArray = (sensesStr || '').split(/ *[,;] */).map(o => o.trim());
    const newSenseObj = new SensesObject;
    for (const sense of sensesArray) {
      if (sense) {
        // Allow any trailing parenthetical note (e.g. "(penetrates magical darkness)") so the sense's
        // range is still parsed instead of the whole entry being dropped; the note itself has no field.
        const senseMatch = sense.match(/^([a-zA-Z ]+) (\d+)( ?ft\.?)?'?( \([^)]*\))?$/);
        if (senseMatch) {
          const senseName: string = senseMatch[1].replace(/\s+/g, '').toLowerCase();
          const parsedRange: number = parseInt(senseMatch[2]);
          switch (senseName) {
            case 'blindsight':
              newSenseObj.blindsight = parsedRange;
              newSenseObj.blindbeyond = /blind beyond this radius/i.test(senseMatch[4] || '');
              break;
            case 'darkvision':
              newSenseObj.darkvision = parsedRange;
              break;
            case 'tremorsense':
              newSenseObj.tremorsense = parsedRange;
              break;
            case 'truesight':
              newSenseObj.truesight = parsedRange;
              break;
            case 'passiveperception':
              newSenseObj.passiveperception = parsedRange;
              break;
            default:
              console.error('Invalid sense name:', senseName);
          }
        } else {
          console.error('Invalid sense format:', sense);
        }
      }
    }
    return SensesObject.buildCustomStr(newSenseObj);
  }

  public static buildCustomStr = (sensesObject: SensesObject): SensesObject => {
    const senseArray = [
      sensesObject.blindsight  ? `blindsight ${sensesObject.blindsight} ft.${sensesObject.blindbeyond ? ' (blind beyond this radius)' : ''}` : '',
      sensesObject.darkvision  ? `darkvision ${sensesObject.darkvision} ft.` : '',
      sensesObject.tremorsense ? `tremorsense ${sensesObject.tremorsense} ft.` : '',
      sensesObject.truesight   ? `truesight ${sensesObject.truesight} ft.` : '',
      `Passive Perception ${sensesObject.passiveperception}`
    ];
    const newSensesObject = structuredClone(sensesObject);
    newSensesObject.customString = senseArray.filter(sense => sense !== '').join(', ');
    return newSensesObject;
  };

}

export default SensesObject;